import {cva} from 'class-variance-authority';

export const pillVariants = cva(
  'z-[1] rounded-r-full text-white whitespace-nowrap',
  {
    variants: {
      color: {
        primary: 'bg-primary-800',
        secondary: 'bg-secondary-700',
        tertiary: 'bg-accent-800',
      },
      size: {
        small: 'text-xs pl-2 pr-3 py-0.5',
        default: 'text-xs pl-3 pr-3 py-1',
        large: 'text-xs pl-3 pr-3 py-1',
        xlarge: 'text-sm pl-3 pr-4 py-1',
      },
    },
    defaultVariants: {color: 'primary', size: 'default'},
  }
);

export const verticalLabelVariants = cva('text-center', {
  variants: {
    color: {
      primary: 'text-primary-800',
      secondary: 'text-secondary-700',
      tertiary: 'text-accent-800',
    },
    size: {
      small: 'text-xs',
      default: 'text-sm',
      large: 'text-base',
      xlarge: 'font-urbanist text-xl',
    },
  },
  defaultVariants: {color: 'primary', size: 'default'},
});
